import axios, { HttpStatusCode } from "axios";

import { useEffect, useState } from "react";
import { getAuthToken, getBaseUri } from "./utils/CommonUtil";

export const axiosHttp = axios.create({
    baseURL: getBaseUri(),
});
axiosHttp.interceptors.request.use(function (config) {
    let authToken = getAuthToken();
    if(authToken){
        config.headers['shop-admin-access-token'] = authToken;
    }
    return config;
});



const ResponseHandler = ({ children }) => {

const [isSet, setIsSet] = useState(false);
    useEffect(() => {
        const responseInterceptor = axiosHttp.interceptors.response.use(response =>{ 
                return response
           
        }, (error) => {
            if (error.status === HttpStatusCode.Forbidden ){
                
            }
            return Promise.reject(error)
        })

        setIsSet(true);

        return () => {
            axiosHttp.interceptors.response.eject(responseInterceptor);
        }
        
    })

    return  isSet ? children : null;
}

export default ResponseHandler;

